import React from 'react';

import styles from './Banner.module.scss';

function Banner() {
  return (
    <div className={styles.banner}>
      <div className={styles.section} />
    </div>
  );
}

export default Banner;
